import { render, staticRenderFns } from "./registeredSuccess.vue?vue&type=template&id=3fce008a&scoped=true&"
import script from "./registeredSuccess.vue?vue&type=script&lang=js&"
export * from "./registeredSuccess.vue?vue&type=script&lang=js&"
import style0 from "./registeredSuccess.vue?vue&type=style&index=0&id=3fce008a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fce008a",
  null
  
)

export default component.exports